import { container, singleton } from "tsyringe";
import PostLikeApi from "api/clapaction/projects/[id]/config/forum/posts/[postId]/PostLikeApi";
import toValidationError from "utils/toValidationError";

@singleton()
export default class ForumPostLikeService {
	private postLikeApi: PostLikeApi = container.resolve(PostLikeApi);

	public async count(projectId: string, postId: string): Promise<{ count: number }> {
		return this.postLikeApi.count(projectId, postId).catch(toValidationError);
	}

	public async isLiked(projectId: string, postId: string): Promise<{ isLiked: boolean }> {
		return this.postLikeApi.isLiked(projectId, postId).catch(toValidationError);
	}

	public async like(projectId: string, postId: string): Promise<void> {
		return this.postLikeApi.like(projectId, postId).catch(toValidationError);
	}

	public async unlike(projectId: string, postId: string): Promise<void> {
		return this.postLikeApi.unlike(projectId, postId).catch(toValidationError);
	}
}
